import { ButtonType, ButtonWidget, CheckBoxWithLabelWidget, TabStyles, TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { HelpTextDiv } from '~src/catalog/styles/LabelStyles';
import { Messages } from '~src/codegen/Localize';
import { ButtonWithUberDialog } from '~src/commonInfra/components/ButtonWithUberDialog';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

import { areLinkedTasksEnabled } from '../utils/LinkedTaskHelpers';

export const LINKEDTASKS_SCHEDULE_INFO_TESTID = 'linked-tasks-schedule-info';
export const LINKEDTASKS_SCHEDULE_INFO_HELP_TESTID = LINKEDTASKS_SCHEDULE_INFO_TESTID + '-help';

const INFO_ICON = 'data_prep_info.svg';
const ICON_PATH = imgPath(INFO_ICON);

const checkboxStyle = {
  display: 'flex',
  paddingBottom: `${TabStyles.Spacing.MediumSpace}px`,
};

const buttonProps = {
  testId: 'LinkedTaskScheduleInfo',
  buttonType: ButtonType.Icon,
  style: {
    padding: `${TabStyles.Spacing.SmallSpace}px`,
    marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
  }
};

export interface LinkedTaskScheduleCheckboxProps {
  checked: boolean;
  checkboxEnabled: boolean;
  handleChange: () => void;
}

export interface LinkedTaskScheduleInfoProps {
  linkedTaskEnabled: boolean;
}

function LinkedTaskScheduleInfo(props: LinkedTaskScheduleInfoProps): JSX.Element {
  return (
    <HelpTextDiv>
      {<span data-tb-test-id={LINKEDTASKS_SCHEDULE_INFO_TESTID}> {props.linkedTaskEnabled ? Messages.linkedTasksSchedulesEnableCheckbox()
        : Messages.linkedTasksSchedulesDisableCheckbox()}</span>}
      <TextLinkWidget
        className={learnMoreStyle}
        href={HelpService.getServerHelpUrlByCategory('prep-conductor-linked-tasks')}
        testId={LINKEDTASKS_SCHEDULE_INFO_HELP_TESTID}
        target="_blank"
        rel="noopener noreferrer"
      >
        {Messages.learnMore()}
      </TextLinkWidget>
    </HelpTextDiv>);
}

export function LinkedTaskScheduleCheckbox(props: LinkedTaskScheduleCheckboxProps): JSX.Element {
  return (
    areLinkedTasksEnabled() ? (
      <div className={style(checkboxStyle)}>
        <CheckBoxWithLabelWidget
          label={Messages.linkedTasks()}
          testId={'linkedtask-schedule-checkbox-tooltip-test-id'}
          checked={props.checked}
          handleChange={props.handleChange}
          disabled={!props.checkboxEnabled}
        />
        <ButtonWithUberDialog
          dialogWidth={300}
          renderButton={showDialog => (
            <ButtonWidget {...buttonProps} onClick={showDialog} title={Messages.linkedTasks()} >
              <img src={ICON_PATH} alt={Messages.linkedTasksMoreInfo()} />
            </ButtonWidget>
          )}
          uberDialogContent={<LinkedTaskScheduleInfo linkedTaskEnabled={props.checkboxEnabled} />}
        />
      </div>
    ) : null
  );
}
